(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7616],{

/***/ 28575:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/signup",
      function () {
        return __webpack_require__(96566);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 50353:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ AppInputPassword; },
/* harmony export */   "p": function() { return /* binding */ AppInput; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14251);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(52875);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(44747);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react_number_format__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57333);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18571);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(91057);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(54799);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _mui_icons_material__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(96406);
/* harmony import */ var _mui_icons_material__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(52186);
/* harmony import */ var _mui_icons_material__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(58883);









var AppInput = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        "data-testid": props.label || props.name,
        InputProps: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
            inputComponent: props.numberFormat ? NumberFormatCustom : undefined,
            inputProps: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props.numberFormat), {
                "data-testid": "__".concat(props.label || props.name, "__"),
                maxLength: props.maxLength
            }),
            endAdornment: props.copyField && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                position: "end",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    "aria-label": "toggle password visibility",
                    onClick: function() {
                        return navigator.clipboard.writeText(props.value || "");
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {})
                })
            })
        }, props.InputProps)
    }, props));
};
var AppInputPassword = function(props) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), showPassword = ref[0], setShowPassword = ref[1];
    var handleClickShowPassword = function() {
        return setShowPassword(!showPassword);
    };
    var handleMouseDownPassword = function() {
        return setShowPassword(!showPassword);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        "data-testid": props.label || props.name,
        InputProps: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
            inputComponent: props.numberFormat ? NumberFormatCustom : undefined,
            inputProps: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props.numberFormat), {
                "data-testid": "__".concat(props.label || props.name, "__")
            }),
            endAdornment: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                position: "end",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    "aria-label": "toggle password visibility",
                    onClick: handleClickShowPassword,
                    onMouseDown: handleMouseDownPassword,
                    children: showPassword ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {}) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {})
                })
            })
        }, props.InputProps)
    }, props), {
        type: showPassword ? "text" : "password"
    }));
};
//@ts-ignore
var NumberFormatCustom = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.forwardRef(function NumberFormatCustom(props, ref) {
    var onChange = props.onChange, other = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(props, [
        "onChange"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_number_format__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, other), {
        getInputRef: ref,
        onValueChange: function(values) {
            onChange({
                target: {
                    name: props.name,
                    value: values.value
                }
            });
        },
        thousandSeparator: true,
        isNumericString: true,
        prefix: ""
    }));
});


/***/ }),

/***/ 8030:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _utils_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15125);
/* harmony import */ var react_google_recaptcha__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34853);




var GoogleCaptcha = function(props) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), changes = ref[0], setChanges = ref[1];
    var captchaRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        props.handleValue(changes);
        props.handleRef(captchaRef);
    }, [
        changes
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_google_recaptcha__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        sitekey: _utils_config__WEBPACK_IMPORTED_MODULE_2__/* ["default"].GOOGLE_CAPTCHA */ .ZP.GOOGLE_CAPTCHA,
        ref: captchaRef,
        size: "invisible",
        onChange: setChanges
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (GoogleCaptcha);


/***/ }),

/***/ 96566:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ signup; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js
var useTranslation = __webpack_require__(26793);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js
var Box = __webpack_require__(99226);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/material/Link/Link.js + 2 modules
var Link = __webpack_require__(23795);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(34727);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(67573);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(14251);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(52875);
// EXTERNAL MODULE: ./node_modules/next/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(46587);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(2734);
// EXTERNAL MODULE: ./node_modules/@mui/material/FormControlLabel/FormControlLabel.js + 1 modules
var FormControlLabel = __webpack_require__(50480);
// EXTERNAL MODULE: ./node_modules/@mui/material/Checkbox/Checkbox.js + 4 modules
var Checkbox = __webpack_require__(69368);
// EXTERNAL MODULE: ./node_modules/@mui/material/Alert/Alert.js + 5 modules
var Alert = __webpack_require__(46901);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(74231);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82580);
// EXTERNAL MODULE: ./node_modules/react-query/es/index.js
var react_query_es = __webpack_require__(88767);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/Trans.js + 1 modules
var Trans = __webpack_require__(59251);
// EXTERNAL MODULE: ./src/components/share/app-input.tsx
var app_input = __webpack_require__(50353);
// EXTERNAL MODULE: ./src/components/share/app-button.tsx
var app_button = __webpack_require__(57858);
// EXTERNAL MODULE: ./src/utils/regex.ts
var regex = __webpack_require__(1233);
// EXTERNAL MODULE: ./src/service/user-management.service.ts
var user_management_service = __webpack_require__(63043);
// EXTERNAL MODULE: ./src/enums/route.enum.ts
var route_enum = __webpack_require__(63915);
// EXTERNAL MODULE: ./node_modules/material-ui-phone-number/dist/index.js
var dist = __webpack_require__(61803);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
// EXTERNAL MODULE: ./src/utils/capitalize.ts
var capitalize = __webpack_require__(82207);
// EXTERNAL MODULE: ./src/components/share/google-captcha.tsx
var google_captcha = __webpack_require__(8030);
;// CONCATENATED MODULE: ./src/components/sign-up/sign-up-form.tsx





















var SignUpForm = function() {
    var ref;
    var theme = (0,useTheme/* default */.Z)();
    var userManagementService = new user_management_service/* default */.Z();
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var router = (0,next_router.useRouter)();
    var query = router.query;
    var ref1 = (0,react.useState)(""), formErrors = ref1[0], setFormErrors = ref1[1];
    //const [captcha, setFormErrors] = useState<string>("");
    var ref2 = (0,react.useState)(false), isCheckedCondition = ref2[0], setIsCheckedCondition = ref2[1];
    var ref3 = (0,react.useState)({}), formDirtyFields = ref3[0], setFormDirtyFields = ref3[1];
    var ref4 = (0,react.useState)(null), captchaRef = ref4[0], setCaptchaRef = ref4[1];
    var ref5 = (0,react.useState)(null), captchaValue = ref5[0], setCaptchaValue = ref5[1];
    //const captchaRef = useRef<any>(null)
    (0,react.useEffect)(function() {
        query && query.invited && query.email && formik.setFieldValue("email", (query === null || query === void 0 ? void 0 : query.email).replace(" ", "+"));
    }, [
        query
    ]);
    var formik = (0,formik_esm/* useFormik */.TA)({
        initialValues: {
            fullName: "",
            firstName: "",
            lastName: "",
            email: "",
            password: "",
            phoneNumber: "",
            phoneAreaCode: "+46",
            confirmPassword: ""
        },
        validationSchema: es/* object */.Ry().shape({
            fullName: es/* string */.Z_().required(t("sign_up_page__error_message__full_name_is_required")),
            firstName: es/* string */.Z_().required(t("sign_up_page__error_message__first_name_is_required")).matches(regex/* AppRegex.nameValidation */.P.nameValidation, t("sign_up_page__error_message__first_name_is_not_valid")),
            lastName: es/* string */.Z_().required(t("sign_up_page__error_message__last_name_is_required")).matches(regex/* AppRegex.nameValidation */.P.nameValidation, t("sign_up_page__error_message__last_name_is_not_valid")),
            email: es/* string */.Z_().required(t("sign_up_page__error_message__email_is_required")).matches(regex/* AppRegex.email */.P.email, t("sign_up_page__error_message__email_is_not_valid")),
            password: es/* string */.Z_().required(t("sign_up_page__error_message__password_is_required")).matches(regex/* AppRegex.strongPassword */.P.strongPassword, t("sign_up_page__error_message__password_is_not_strong_enough")),
            phoneNumber: es/* string */.Z_().required(t("sign_up_page__error_message__phone_number_is_required")).matches(regex/* AppRegex.phone */.P.phone, t("sign_up_page__error_message__phone_number_is_not_valid")),
            phoneAreaCode: es/* string */.Z_().required(t("sign_up_page__error_message__phone_area_code_is_required")).matches(regex/* AppRegex.areaCode */.P.areaCode, t("sign_up_page__error_message__area_code_is_not_valid")),
            confirmPassword: es/* string */.Z_().required(t("sign_up_page__error_message__confirm_password_is_required"))
        }),
        onSubmit: function onSubmit(values) {
            if (values.password === values.confirmPassword) {
                var ref;
                var finalData = {
                    email: values.email,
                    fullName: values.fullName,
                    password: values.password,
                    phoneNumber: "".concat(values.phoneAreaCode, " ").concat(values.phoneNumber),
                    captchaToken: captchaValue
                };
                (ref = captchaRef.current) === null || ref === void 0 ? void 0 : ref.reset();
                signUpMutation.mutate(finalData);
            }
        }
    });
    var signUpMutation = (0,react_query_es.useMutation)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(userData) {
            var ref, data, hasError, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setFormErrors("");
                        return [
                            4,
                            userManagementService.signup(userData)
                        ];
                    case 1:
                        ref = _state.sent(), data = ref.data, hasError = ref.hasError, error = ref.error;
                        if (hasError) {
                            if (error === 409) {
                                setFormErrors(t("sign_up_page__error_message__user_already_exists"));
                                throw new Error("");
                            } else if (error === 400 || error === 403) {
                                setFormErrors(t("sign_up_page__error_message__form_error"));
                                throw new Error("");
                            } else {
                                setFormErrors("");
                            }
                        }
                        return [
                            2,
                            data
                        ];
                }
            });
        });
        return function(userData) {
            return _ref.apply(this, arguments);
        };
    }(), {
        onSuccess: function() {
            router.push("".concat(route_enum/* EAPP_ROUTE.CONFIRM_EMAIL */.$X.CONFIRM_EMAIL, "?email=").concat(encodeURIComponent(formik.values.email)));
        }
    });
    var inputs = [
        {
            label: t("sign_up_page__full_name"),
            name: "fullName",
            autoFocus: false,
            type: "text"
        },
        {
            label: t("sign_up_page__email"),
            name: "email",
            autoFocus: false,
            type: "email"
        },
        {
            label: t("sign_up_page__password"),
            name: "password",
            autoFocus: false,
            type: "password"
        },
        {
            label: t("sign_up_page__confirm_password"),
            name: "confirmPassword",
            autoFocus: false,
            type: "password"
        },
        {
            label: t("sign_up_page__phone_number"),
            name: "phoneNumber",
            autoFocus: false,
            type: "number"
        }, 
    ];
    var handleFormikChange = function(e) {
        if (formDirtyFields[e.target.name] === undefined) {
            setFormDirtyFields((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formDirtyFields), (0,_define_property/* default */.Z)({}, e.target.name, true)));
        }
        formik.handleChange(e);
    };
    var renderInput = function(input) {
        return input.name === "password" || input.name === "confirmPassword" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(app_input/* AppInputPassword */.n, {
            variant: "outlined",
            autoFocus: input.autoFocus,
            disabled: input.name === "email" && query.invited && query.email ? true : false,
            error: input.name === "confirmPassword" ? Boolean(formDirtyFields["confirmPassword"] && formik.touched.confirmPassword && formik.errors.confirmPassword || formDirtyFields["confirmPassword"] && formik.touched.confirmPassword && formik.values.confirmPassword !== formik.values.password) : Boolean(formDirtyFields[input.name] && formik.touched[input.name] && formik.errors[input.name]),
            fullWidth: true,
            helperText: input.name === "confirmPassword" ? formDirtyFields["confirmPassword"] && formik.errors.confirmPassword && formik.touched.confirmPassword ? formik.errors.confirmPassword : formik.touched.confirmPassword && formik.values.confirmPassword !== formik.values.password ? t("account_page__error_message__confirm_password_is_not_valid") : "" : formDirtyFields["confirmPassword"] && formik.touched[input.name] && formik.errors[input.name],
            label: input.label,
            margin: "normal",
            name: input.name,
            onChange: handleFormikChange,
            onBlur: formik.handleBlur,
            type: input.type,
            value: formik.values[input.name]
        }, input.name) : /*#__PURE__*/ (0,jsx_runtime.jsx)(app_input/* AppInput */.p, {
            variant: "outlined",
            disabled: input.name === "email" && query.invited && query.email ? true : false,
            autoFocus: input.autoFocus,
            error: Boolean(formDirtyFields[input.name] && formik.touched[input.name] && formik.errors[input.name]),
            fullWidth: true,
            helperText: formDirtyFields[input.name] && formik.touched[input.name] && formik.errors[input.name],
            label: input.label,
            margin: "normal",
            name: input.name,
            onChange: handleFormikChange,
            onBlur: formik.handleBlur,
            type: input.type,
            value: formik.values[input.name]
        }, input.name);
    };
    var handleCheckCondition = function(e) {
        setIsCheckedCondition(e.target.checked);
    };
    var handleFirstNameChange = function(e) {
        formik.setFieldValue("firstName", e.target.value);
        if (formik.values.lastName !== "") {
            formik.setFieldValue("fullName", "".concat((0,capitalize/* capitalize */.k)(e.target.value), " ").concat((0,capitalize/* capitalize */.k)(formik.values.lastName)));
        } else {
            formik.setFieldValue("fullName", "".concat((0,capitalize/* capitalize */.k)(e.target.value)));
        }
        handleFormikChange(e);
    };
    var handleLastNameChange = function(e) {
        formik.setFieldValue("lastName", e.target.value);
        if (formik.values.firstName !== "") {
            formik.setFieldValue("fullName", "".concat((0,capitalize/* capitalize */.k)(formik.values.firstName), " ").concat((0,capitalize/* capitalize */.k)(e.target.value)));
        } else {
            formik.setFieldValue("fullName", "".concat((0,capitalize/* capitalize */.k)(e.target.value)));
        }
        handleFormikChange(e);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
        noValidate: true,
        onSubmit: formik.handleSubmit,
        onChange: function() {
            var ref;
            return captchaRef === null || captchaRef === void 0 ? void 0 : (ref = captchaRef.current) === null || ref === void 0 ? void 0 : ref.execute();
        },
        children: [
            inputs.map(function(input) {
                return input.name === "fullName" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    sx: {
                        display: "flex"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(app_input/* AppInput */.p, {
                            variant: "outlined",
                            autoFocus: true,
                            error: Boolean(formDirtyFields["firstName"] && formik.touched["firstName"] && formik.errors["firstName"]),
                            fullWidth: true,
                            helperText: formDirtyFields["firstName"] && formik.touched["firstName"] && formik.errors["firstName"],
                            label: "First Name",
                            margin: "normal",
                            name: "firstName",
                            onChange: handleFirstNameChange,
                            onBlur: formik.handleBlur,
                            type: input.type,
                            value: formik.values["firstName"],
                            sx: {
                                mr: "0.8rem"
                            }
                        }, "firstName"),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(app_input/* AppInput */.p, {
                            variant: "outlined",
                            error: Boolean(formDirtyFields["lastName"] && formik.touched["lastName"] && formik.errors["lastName"]),
                            fullWidth: true,
                            helperText: formDirtyFields["lastName"] && formik.touched["lastName"] && formik.errors["lastName"],
                            label: "Last Name",
                            margin: "normal",
                            name: "lastName",
                            onChange: handleLastNameChange,
                            onBlur: formik.handleBlur,
                            type: input.type,
                            value: formik.values["lastName"]
                        }, "lastName")
                    ]
                }, "".concat(input.name, "-wrapper")) : input.name === "phoneNumber" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    sx: {
                        display: "flex"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((dist_default()), {
                            variant: "outlined",
                            label: t("sign_up_page__phone_area_code"),
                            value: formik.values.phoneAreaCode,
                            name: "phoneAreaCode",
                            size: "medium",
                            sx: {
                                width: "18rem",
                                mr: "0.8rem",
                                mt: "1.6rem",
                                mb: "0.8rem"
                            },
                            inputProps: {
                                maxLength: 5
                            },
                            preferredCountries: [
                                "se"
                            ],
                            error: Boolean(formDirtyFields["phoneAreaCode"] && formik.touched.phoneAreaCode && formik.errors.phoneAreaCode),
                            helperText: formDirtyFields["phoneAreaCode"] && formik.touched.phoneAreaCode && formik.errors.phoneAreaCode,
                            onChange: function(e) {
                                return formik.setFieldValue("phoneAreaCode", e);
                            }
                        }),
                        renderInput(input)
                    ]
                }, "".concat(input.name, "-wrapper")) : renderInput(input);
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                sx: {
                    color: "text.primary",
                    mt: 3
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                    control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                        onChange: handleCheckCondition,
                        "data-testid": "signup-checkbox"
                    }),
                    label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* Trans */.c, {
                        "data-testid": "I-read-the-condition",
                        i18nKey: "sign_up_page__I_have_read_the_terms_and_conditions",
                        components: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                style: {
                                    color: theme.palette.primary.dark,
                                    textDecoration: "underline"
                                },
                                href: "https://parsly.com/en/terms-and-conditions/",
                                "data-testid": "regulation-link"
                            }), 
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                sx: {
                    mt: 2
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(google_captcha/* default */.Z, {
                    handleValue: setCaptchaValue,
                    handleRef: setCaptchaRef
                })
            }),
            formErrors && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                sx: {
                    mt: 3
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert/* default */.Z, {
                    severity: "error",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                            children: formErrors
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                sx: {
                    mt: 2
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(app_button/* default */.Z, {
                    disabled: !isCheckedCondition || !formik.isValid && formik.dirty || !formik.dirty || !(captchaRef === null || captchaRef === void 0 ? void 0 : (ref = captchaRef.current) === null || ref === void 0 ? void 0 : ref.getValue()),
                    fullWidth: true,
                    size: "large",
                    type: "submit",
                    variant: "contained",
                    "data-testid": "sign_up_page__register",
                    loading: signUpMutation.isLoading,
                    children: t("sign_up_page__register")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                sx: {
                    mt: 2
                }
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/layout/login/sign-up/SignUpLayout.tsx + 3 modules
var SignUpLayout = __webpack_require__(90661);
// EXTERNAL MODULE: ./src/components/login/left-message/LeftSideMessage.tsx + 1 modules
var LeftSideMessage = __webpack_require__(13395);
;// CONCATENATED MODULE: ./src/pages/signup/index.tsx









var SignUp = function() {
    var ref;
    var router = (0,next_router.useRouter)();
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var invited = router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : ref.invited;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SignUpLayout/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LeftSideMessage/* default */.Z, {
                title: "sign_up_page__create_your_first_account",
                message: invited ? "sign_up_page__invited_description" : "sign_up_page__join_parsly_today",
                secondText: "sign_up_page__fill_information"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                sx: {
                    p: "2.4rem",
                    "@media (min-width: 769px)": {
                        maxWidth: "79.2rem",
                        p: "16.4rem 12rem 10.8rem 4.8rem"
                    }
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        sx: {
                            mb: "0.8rem"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "h6",
                            children: t("sign_up_page__fill_form")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SignUpForm, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        sx: {
                            display: "flex",
                            justifyContent: "center",
                            mt: 4
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: route_enum/* EAPP_ROUTE.LOGIN */.$X.LOGIN,
                            passHref: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                color: "primary",
                                variant: "body2",
                                "data-testid": "sign_up_page__already_have_parsly_account",
                                children: t("sign_up_page__already_have_parsly_account")
                            })
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var signup = (SignUp);


/***/ }),

/***/ 63043:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ UserManagementService; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75815);
/* harmony import */ var _utils_client__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5904);


var UserManagementService = function UserManagementService(unitId) {
    "use strict";
    var _this = this;
    (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, UserManagementService);
    this.prefix = "user-management";
    this.headers = new Headers();
    this.signup = function(data) {
        return _utils_client__WEBPACK_IMPORTED_MODULE_0__/* ["default"].create */ .Z.create("".concat(_this.prefix, "/users/signup"), data);
    };
    this.getUsers = function() {
        return _utils_client__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("".concat(_this.prefix, "/users"), null, _this.headers);
    };
    this.accessRoleToUser = function(userId, data) {
        return _utils_client__WEBPACK_IMPORTED_MODULE_0__/* ["default"].create */ .Z.create("".concat(_this.prefix, "\n/users/").concat(userId, "/permissions"), data, _this.headers);
    };
    this.deleteUserRole = function(data) {
        return _utils_client__WEBPACK_IMPORTED_MODULE_0__/* ["default"].remove */ .Z.remove("".concat(_this.prefix, "/users/").concat(data.userId, "/units/").concat(data.unitId, "/roles/").concat(data.role), null, _this.headers);
    };
    this.getInvitedUsers = function(organizationId) {
        return _utils_client__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("".concat(_this.prefix, "/organizations/").concat(organizationId, "/invitations"), null, _this.headers);
    };
    this.inviteUser = function(userID, data) {
        _this.headers.append("X-USER-ID", userID.toString());
        return _utils_client__WEBPACK_IMPORTED_MODULE_0__/* ["default"].create */ .Z.create("".concat(_this.prefix, "/organization-invitations"), data, _this.headers);
    };
    this.editInviteUser = function(ids, data) {
        return _utils_client__WEBPACK_IMPORTED_MODULE_0__/* ["default"].update */ .Z.update("".concat(_this.prefix, "/organizations/").concat(ids.organizationId, "/invitations/").concat(ids.invitationId), data, _this.headers);
    };
    if (unitId) {
        this.headers.append("X-UNIT-ID", unitId);
    }
};



/***/ }),

/***/ 82207:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ capitalize; }
/* harmony export */ });
var capitalize = function(text) {
    return text.replace(/\w\S*/g, function(word) {
        return word.charAt(0).toUpperCase() + word.substr(1).toLowerCase();
    });
};


/***/ }),

/***/ 1233:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ AppRegex; }
/* harmony export */ });
var AppRegex = {
    digitGreterThan1000: /^[1-9][0-9]{3}$/,
    number: /^-?\d*(\.\d+)?$/,
    integer: /^\d+$/,
    mobile: /^((\+|00)?\d{1,3})?[1-9][0-9]{9}$/,
    phone: /^([+]?[(]?[0-9]{3}[)]?)?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/im,
    areaCode: /^[+]?[(]?[0-9]{1,4}[)]?/,
    website: /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9]\.[^\s]{2,})/,
    smsCode: /^\d{4}$/,
    organizationNumber: /^[0-9]*$/i,
    email: /^((?!\.)[\w\-\._+]*[^.])(@\w+)(\.\w+(\.\w+)?[^.\W])$/i,
    strongPassword: /(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})/,
    url: /((https?):\/\/)?(www\.)?[a-z0-9\-._~:&?#@!$'()*+,;=%]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#%&-]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/,
    nameValidation: RegExp("^\\p{L}+(?:[ '-]\\p{L}+)*$", "u")
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3626,2066,1148,7836,1477,3382,8571,1214,1664,7333,1524,551,1923,4437,9379,9774,2888,179], function() { return __webpack_exec__(16395), __webpack_exec__(28575); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);